module.exports = __webpack_public_path__ + "img/pr-14.3dfa1c28.png";